@let userPosition = userPosition$ | async;

@if (userPosition) {
  @let userPositionMarkerOptions = userPositionMarkerOptions$ | async;

  @if (userPositionMarkerOptions) {
    <map-marker [position]="userPosition" [options]="userPositionMarkerOptions"></map-marker>
  } @else {
    <map-marker [position]="userPosition"></map-marker>
  }
}
